<template>
  <div>
    <assessorFireTaxXRefTab/>
  </div>
</template>
<script>
import assessorFireTaxXRefTab from '../../../../components/tax/SpecialTaxItems/newTaxRoll/assessorFireTaxXRef.vue';

export default {
  name: 'assessorFireTaxXRef',
  components: {
    assessorFireTaxXRefTab,
  },
};
</script>
